import { j as $ } from "./atoms-v218.js";
import { forwardRef as R, useContext as f } from "react";
import V from "./atoms-v2122.js";
import { GridContext as d } from "./atoms-v2123.js";
import { GridHelperContext as h } from "./atoms-v2124.js";
import { breakpoints as w } from "./atoms-v2125.js";
import { Column as D } from "./atoms-v2126.js";
const E = R(
  ({
    autoFill: x,
    bleed: C = !1,
    children: v,
    className: b = "",
    id: j,
    large: s,
    max: e,
    maxPlus: r,
    medium: m,
    offset: G = void 0,
    small: n,
    span: l,
    tagName: g = "div",
    xLarge: a,
    ...k
  }, B) => {
    const { activeBreakpoints: o, colGap: c, columns: u } = f(d), { isDebugging: y, isGridVisible: N } = f(h), i = { small: n, medium: m, large: s, xLarge: a, max: e, maxPlus: r }, p = o && Object.keys(o).find((t) => o[t]), P = p && (i == null ? void 0 : i[p]) || void 0;
    return /* @__PURE__ */ $.jsx(
      d.Provider,
      {
        value: {
          activeBreakpoints: o,
          colGap: c,
          columns: P || l || u || V(w, "maxPlus.columns")
        },
        children: /* @__PURE__ */ $.jsx(
          D,
          {
            $autoFill: x,
            $bleed: C,
            $colGap: c,
            $columns: u,
            $debug: y,
            $isGridVisible: N,
            $large: s,
            $max: e,
            $maxPlus: r,
            $medium: m,
            $offset: G,
            $small: n,
            $span: l,
            $xLarge: a,
            as: g,
            className: [b, "atoms-column"].filter((t) => t).join(" "),
            id: j,
            ref: B,
            ...k,
            children: v
          }
        )
      }
    );
  }
);
E.displayName = "Column";
export {
  E as Column
};
